import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "back-button-section" }
const _hoisted_3 = { class: "opportunity-header" }
const _hoisted_4 = { class: "header-top" }
const _hoisted_5 = { class: "header-left" }
const _hoisted_6 = { class: "header-info" }
const _hoisted_7 = { class: "opportunity-title" }
const _hoisted_8 = { class: "opportunity-meta" }
const _hoisted_9 = {
  class: "meta-item meta-item--function",
  title: "Funcție"
}
const _hoisted_10 = {
  key: 0,
  class: "meta-item meta-item--email",
  title: "Email"
}
const _hoisted_11 = {
  key: 1,
  class: "meta-item meta-item--phone",
  title: "Telefon Mobil"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = {
  key: 0,
  class: "dx-icon-search meta-item--link-icon"
}
const _hoisted_14 = {
  class: "meta-item meta-item--owner",
  title: "Responsabil (Owner)"
}
const _hoisted_15 = { class: "two-column-layout" }
const _hoisted_16 = { class: "left-column" }
const _hoisted_17 = { class: "details-card" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "right-column" }
const _hoisted_20 = { class: "section-card" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { style: {"height":"100%","overflow":"hidden","position":"relative"} }
const _hoisted_23 = {
  key: 0,
  class: "popup-loading"
}
const _hoisted_24 = {
  key: 1,
  class: "no-opportunity"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_contactForm = _resolveComponent("contactForm")!
  const _component_CardOpportunities = _resolveComponent("CardOpportunities")!
  const _component_GridParteneriDetalii = _resolveComponent("GridParteneriDetalii")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!

  return (_openBlock(), _createBlock(_component_DxScrollView, { class: "opportunity-details-container" }, {
    default: _withCtx(() => [
      (_ctx.contact)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_DxButton, {
                icon: "arrowleft",
                text: "Înapoi la listă",
                "styling-mode": "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
                class: "back-btn"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "opportunity-icon" }, [
                    _createElementVNode("i", { class: "dx-icon-box" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.contact.Nume) + " " + _toDisplayString(_ctx.contact.Prenume || ''), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "dx-icon-info" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.contact.Titlu || 'Fără funcție'), 1)
                      ]),
                      (_ctx.contact.Email)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "dx-icon-email" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.contact.Email), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.contact.TelMobil)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "dx-icon-tel" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.contact.TelMobil), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(["meta-item meta-item--account", { 'meta-item--clickable': _ctx.contact.AccountID }]),
                        title: _ctx.contact.AccountID ? 'Click pentru detalii partener' : 'Cont / Partener',
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPartener && _ctx.openPartener(...args)))
                      }, [
                        _cache[9] || (_cache[9] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.contact.Account?.Nume || _ctx.contact.AccountNume || 'Fără partener') + " ", 1),
                        (_ctx.contact.AccountID)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_12),
                      _createElementVNode("span", _hoisted_14, [
                        _cache[10] || (_cache[10] = _createElementVNode("i", { class: "dx-icon-user" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.contact.Owner || 'Fără agent'), 1)
                      ])
                    ])
                  ])
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "header-actions" }, null, -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", { class: "card-header-icon" }, [
                      _createElementVNode("i", { class: "dx-icon-doc" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Detalii Contact")
                  ], -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_contactForm, {
                      "opportunity-data": _ctx.contact,
                      "is-editing": false,
                      onSaved: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('refresh-data')))
                    }, null, 8, ["opportunity-data"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", {
                      class: "card-header-icon",
                      style: {"background":"linear-gradient(135deg, #10b981 0%, #34d399 100%)"}
                    }, [
                      _createElementVNode("i", { class: "dx-icon-event" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Oportunități")
                  ], -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_CardOpportunities, {
                      "contact-id": _ctx.contact?.ID,
                      "opportunity-data": _ctx.contact,
                      "account-id": _ctx.contact?.AccountID
                    }, null, 8, ["contact-id", "opportunity-data", "account-id"])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_DxPopup, {
              visible: _ctx.isPartenerPopupVisible,
              "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isPartenerPopupVisible) = $event)),
              "drag-enabled": false,
              "close-on-outside-click": true,
              "show-title": false,
              "full-screen": true,
              "show-close-button": false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_DxButton, {
                    icon: "close",
                    "styling-mode": "text",
                    class: "popup-close-btn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isPartenerPopupVisible = false))
                  }),
                  (_ctx.isLoadingPartener)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("i", { class: "dx-icon-refresh popup-loading-icon" }, null, -1),
                        _createElementVNode("span", null, "Se încarcă...", -1)
                      ]))]))
                    : (_ctx.selectedPartenerData)
                      ? (_openBlock(), _createBlock(_component_GridParteneriDetalii, {
                          key: 1,
                          partener: _ctx.selectedPartenerData,
                          onBack: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isPartenerPopupVisible = false))
                        }, null, 8, ["partener"]))
                      : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("div", { class: "no-opportunity-icon" }, [
              _createElementVNode("i", { class: "dx-icon-box" })
            ], -1),
            _createElementVNode("p", { class: "no-opportunity-text" }, "Niciun contact selectat", -1),
            _createElementVNode("p", { class: "no-opportunity-subtext" }, "Selectează un contact din listă pentru a vedea detaliile", -1)
          ]))]))
    ]),
    _: 1
  }))
}